import { set, unset } from "../../js/lib/util";

const ACCORDION_QUESTION_SELECTOR = ".js-accordion-question";
const ACCORDION_CONTENT_SELECTOR = ".js-accordion-content";
const NO_JS_CLASS = "no-js";
const ACCORDION_TRIGGER_CLASSES = [
  "p1",
  "accordion-trigger",
  "accordion__trigger",
];

const initAccordionTrigger = (questionEl: HTMLElement) => {
  const accordionId = questionEl.getAttribute("data-accordion-id");
  const accordionText = questionEl.textContent;

  if (!accordionId || !accordionText) {
    return;
  }
  questionEl.setAttribute("aria-controls", accordionId);
  questionEl.setAttribute("aria-expanded", "false");
  ACCORDION_TRIGGER_CLASSES.map((accordionClass) => {
    set(questionEl, accordionClass);
  });
};

const handleTriggerAccordion = (e) => {
  if (!e.target.closest(ACCORDION_QUESTION_SELECTOR)) {
    return;
  }

  const accordionTrigger = e.target;

  const isAccordionOpened = accordionTrigger.getAttribute("aria-expanded");
  if (isAccordionOpened === "false") {
    openAccordion(accordionTrigger);
  } else {
    closeAccordion(accordionTrigger);
  }
};

const openAccordion = (trigger) => {
  const accordionId = trigger.getAttribute("aria-controls");
  const accordionContentEl = document.getElementById(accordionId);
  if (!accordionContentEl) {
    return;
  }
  trigger.setAttribute("aria-expanded", "true");
  trigger.setAttribute("aria-disabled", "true");
  accordionContentEl.setAttribute("aria-hidden", "false");
};

const closeAccordion = (trigger) => {
  const accordionId = trigger.getAttribute("aria-controls");
  const accordionContentEl = document.getElementById(accordionId);
  if (!accordionContentEl) {
    return;
  }
  trigger.setAttribute("aria-expanded", "false");
  trigger.removeAttribute("aria-disabled", "true");
  accordionContentEl.setAttribute("aria-hidden", "true");
};

export default (el) => {
  unset(el, NO_JS_CLASS);
  const accordionQuestionEls = el.querySelectorAll(ACCORDION_QUESTION_SELECTOR);
  if (accordionQuestionEls.length) {
    accordionQuestionEls.forEach((questionEl) => {
      initAccordionTrigger(questionEl);
    });
  }

  const accordionContentEls = el.querySelectorAll(ACCORDION_CONTENT_SELECTOR);
  if (accordionContentEls.length) {
    accordionContentEls.forEach((contentEl) => {
      contentEl.setAttribute("aria-hidden", "true");
    });
  }

  document.addEventListener("click", handleTriggerAccordion);
};
